import { CreateAppointmentByAdvocateMeta, CreateAppointmentByAdvocatePayload } from 'types/store/CreateAppointmentByAdvocate';
import { createAsyncReducer } from 'utils/Redux';

import { createAppointmentByAdvocateActions } from '../actions';

export default createAsyncReducer<CreateAppointmentByAdvocateMeta, CreateAppointmentByAdvocatePayload>(createAppointmentByAdvocateActions);
